// extracted by mini-css-extract-plugin
export default {"content":"xR","wrapper":"yR","gif":"zR","textContent":"AR","gifContainer":"BR","proteinGif":"CR","counter_img":"ER","usage-container":"FR","usage-list":"GR","checklist":"HR","counter_title":"IR","counter_wrapper":"JR","active":"KR","usage-counter":"LR","line":"MR"};
    if(module.hot) {
      // 1743628927928
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  